import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type OpenOpts = { phoneBind?: boolean };

type PersonalCenterState = {
  open: boolean;
  /** 打开个人中心时自动弹出「绑定手机号」 */
  phoneBindRequested: boolean;
  openPersonalCenter: (opts?: OpenOpts) => void;
  closePersonalCenter: () => void;
  clearPhoneBindRequest: () => void;
};

const PersonalCenterContext = createContext<PersonalCenterState | null>(null);

export function PersonalCenterProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [phoneBindRequested, setPhoneBindRequested] = useState(false);

  const openPersonalCenter = useCallback((opts?: OpenOpts) => {
    setPhoneBindRequested(Boolean(opts?.phoneBind));
    setOpen(true);
  }, []);

  const closePersonalCenter = useCallback(() => {
    setOpen(false);
    setPhoneBindRequested(false);
  }, []);

  const clearPhoneBindRequest = useCallback(() => {
    setPhoneBindRequested(false);
  }, []);

  const value = useMemo(
    () => ({
      open,
      phoneBindRequested,
      openPersonalCenter,
      closePersonalCenter,
      clearPhoneBindRequest,
    }),
    [
      open,
      phoneBindRequested,
      openPersonalCenter,
      closePersonalCenter,
      clearPhoneBindRequest,
    ],
  );
  return (
    <PersonalCenterContext.Provider value={value}>
      {children}
    </PersonalCenterContext.Provider>
  );
}

export function usePersonalCenter() {
  const ctx = useContext(PersonalCenterContext);
  if (!ctx) {
    throw new Error(
      "usePersonalCenter must be used within PersonalCenterProvider",
    );
  }
  return ctx;
}
